import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  Alert,
  Card,
  CardContent,
  CardMedia,
  Chip,
} from '@mui/material';
import {
  Receipt,
  VolunteerActivism,
} from '@mui/icons-material';
import ContactTiles from '../components/shared/ContactTiles';

const DonationsPage: React.FC = () => {
  // Remove unused state and functions
  // const [formData, setFormData] = useState<DonationForm>({
  //   name: '',
  //   email: '',
  //   amount: '',
  //   type: '',
  //   message: '',
  // });

  // const [submitStatus, setSubmitStatus] = useState<{
  //   success?: boolean;
  //   message?: string;
  // }>({});

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown }>) => {
  //   const { name, value } = e.target;
  //   setFormData(prev => ({
  //     ...prev,
  //     [name as string]: value,
  //   }));
  // };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   try {
  //     // TODO: Implement API call to process donation
  //     setSubmitStatus({
  //       success: true,
  //       message: 'Thank you for your donation! We will send you a confirmation email shortly.',
  //     });
  //     setFormData({
  //       name: '',
  //       email: '',
  //       amount: '',
  //       type: '',
  //       message: '',
  //     });
  //   } catch (error) {
  //     setSubmitStatus({
  //       success: false,
  //       message: 'There was an error processing your donation. Please try again.',
  //     });
  //   }
  // };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Hero Section */}
      <Box sx={{ mb: 6, textAlign: 'center' }}>
        <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          Support Our Mission
        </Typography>
        <Typography variant="h5" color="text.secondary" paragraph sx={{ maxWidth: 800, mx: 'auto' }}>
          New Life Community Care serves the community in a variety of ways, from running the Foodbarn to feed people physically, to healing people emotionally, and also building them up spiritually.
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: 600, mx: 'auto', mb: 4 }}>
          We rely on donations and sponsors to meet these needs and value any contribution you can make.
        </Typography>
      </Box>

      <Grid container spacing={6}>
        {/* Ways to Donate Section */}
        <Grid item xs={12} md={6}>
          <Card sx={{ p: 4, height: '100%' }}>
            <CardContent>
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
                Ways to Donate
              </Typography>
              
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Card>
                    <CardMedia
                      component="img"
                      height="140"
                      image="/images/donations/monetary.jpg"
                      alt="Monetary Donations"
                    />
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        Monetary Donations
                      </Typography>
                      <Typography variant="body2" color="text.secondary" paragraph>
                        Your financial support helps us purchase food items and maintain our operations.
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        All donations are tax-deductible.
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card>
                    <CardMedia
                      component="img"
                      height="140"
                      image="/images/donations/food.jpg"
                      alt="Food Donations"
                    />
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        Food Donations
                      </Typography>
                      <Typography variant="body2" color="text.secondary" paragraph>
                        We accept non-perishable food items that are within their use-by date.
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Please contact us to arrange drop-off times.
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12}>
                  <Card>
                    <CardMedia
                      component="img"
                      height="140"
                      image="/images/donations/volunteer.jpg"
                      alt="Volunteer Support"
                    />
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        Volunteer Support
                      </Typography>
                      <Typography variant="body2" color="text.secondary" paragraph>
                        Your time and skills are valuable to our cause.
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Visit our Volunteer page to learn more about opportunities.
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Direct Bank Transfer Section */}
        <Grid item xs={12} md={6}>
          <Card sx={{ p: 4, mb: 4 }}>
            <CardContent>
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
                Direct Bank Transfer
              </Typography>
              <Typography variant="body1" paragraph>
                Donations can be made directly to the following account:
              </Typography>
              
              <Box sx={{ bgcolor: 'grey.50', p: 3, borderRadius: 2, mb: 3 }}>
                <Typography variant="h6" gutterBottom>
                  Community Care Gift Fund
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">
                      BSB:
                    </Typography>
                    <Typography variant="body1" fontWeight="bold">
                      064 794
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">
                      Account:
                    </Typography>
                    <Typography variant="body1" fontWeight="bold">
                      1002 4379
                    </Typography>
                  </Grid>
                </Grid>
              </Box>

              <Alert severity="info" sx={{ mb: 3 }}>
                <Typography variant="body2">
                  Please contact the New Life Community Care office if you require a Tax certificate.
                </Typography>
              </Alert>
            </CardContent>
          </Card>

          {/* Coming Soon Card */}
          <Card sx={{ p: 4, bgcolor: 'primary.light', color: 'primary.contrastText' }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                💳 Card Donations Coming Soon
              </Typography>
              <Typography variant="body1" paragraph>
                We're working on adding secure online card payment options to make donating even easier.
              </Typography>
              <Chip 
                label="Coming Soon" 
                color="primary" 
                variant="outlined"
                icon={<Receipt />}
                sx={{ bgcolor: 'white', color: 'primary.main' }}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Volunteer Section */}
      <Box sx={{ mb: 6, mt: 6 }}>
        <Alert severity="warning" sx={{ fontSize: '1rem' }}>
          <Box display="flex" alignItems="center" gap={2}>
            <VolunteerActivism sx={{ fontSize: 32 }} />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                🚨 WE URGENTLY NEED VOLUNTEERS!
              </Typography>
              <Typography variant="body1" paragraph>
                The <strong>Foodbarn</strong> needs volunteers! Any age welcome. Do you need to get out and feel great about yourself? 
                Come and help the team making a difference in thousands of lives.
              </Typography>
              <Typography variant="body2" paragraph>
                We are a registered workplace for Community Services, Centrelink & SPER.
              </Typography>
            </Box>
          </Box>
        </Alert>
      </Box>

      {/* Contact Information */}
      <ContactTiles title="📞 Get In Touch" />
    </Container>
  );
};

export default DonationsPage; 